import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { HiArrowsRightLeft, HiOutlineUserGroup, HiOutlineChevronDown } from "react-icons/hi2";
import { FaPlaneDeparture, FaPlaneArrival, FaCalendarAlt, FaSearch } from "react-icons/fa";
import axios from "axios";
import { baseurl } from "../../baseurl";
import Swal from "sweetalert2";
import "../HomeComponent/booking-forms/css/flightform.css";

const FlightSearch = () => {
  const navigate = useNavigate();
  const [tripType, setTripType] = useState("One Way");
  const [showTravelerModal, setShowTravelerModal] = useState(false);
  const travelerRef = useRef(null);

  // Search States
  const [fromSearch, setFromSearch] = useState({ query: "", results: [], loading: false });
  const [toSearch, setToSearch] = useState({ query: "", results: [], loading: false });

  // Final Form State
  const [formData, setFormData] = useState({
    fromTerminal: null,
    toTerminal: null,
    departureDate: "",
    returnDate: "",
    adults: 1,
    children: 0,
    infants: 0,
    cabinClass: "Economy",
    preferredAirline: "Any"
  });

  // 1. Initialize Flatpickr
  useEffect(() => {
    if (window.flatpickr) {
      window.flatpickr(".date-input", {
        dateFormat: "Y-m-d",
        minDate: "today",
        disableMobile: "true",
        onChange: (selectedDates, dateStr, instance) => {
          const fieldName = instance.element.getAttribute("name");
          setFormData(prev => ({ ...prev, [fieldName]: dateStr }));
        }
      });
    }
  }, [tripType]);

  // 2. Click Outside Logic to close traveler modal
  useEffect(() => {
    const closeModals = (e) => {
      if (travelerRef.current && !travelerRef.current.contains(e.target)) {
        setShowTravelerModal(false);
      }
    };
    document.addEventListener("mousedown", closeModals);
    return () => document.removeEventListener("mousedown", closeModals);
  }, []);

  // 3. API Search Logic with simple debounce handling
  const handleSearch = async (query, type) => {
    const setter = type === "from" ? setFromSearch : setToSearch;
    setter(prev => ({ ...prev, query }));

    if (query.length > 1) {
      try {
        const res = await axios.get(`${baseurl}/searchTerminals?q=${query}`);
        setter(prev => ({ ...prev, results: res.data.data || [] }));
      } catch (err) {
        console.error("Terminal Search Error:", err);
      }
    } else {
      setter(prev => ({ ...prev, results: [] }));
    }
  };

  const selectTerminal = (terminal, type) => {
    if (type === "from") {
      setFormData(prev => ({ ...prev, fromTerminal: terminal }));
      setFromSearch({ query: terminal.terminal_name, results: [] });
    } else {
      setFormData(prev => ({ ...prev, toTerminal: terminal }));
      setToSearch({ query: terminal.terminal_name, results: [] });
    }
  };

  const updateCount = (field, op) => {
    setFormData(prev => ({
      ...prev,
      [field]: op === "inc" ? prev[field] + 1 : Math.max(field === "adults" ? 1 : 0, prev[field] - 1)
    }));
  };

  // 4. Handle Final Search & Navigation (FIXED SUBMIT)
  const onSearchFlights = () => {
    const { fromTerminal, toTerminal, departureDate, returnDate, adults, children, infants, cabinClass } = formData;

    // Validation
    if (!fromTerminal || !toTerminal || !departureDate) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Details',
        text: 'Please ensure From, To, and Departure Date are selected.',
        confirmButtonColor: '#166070'
      });
      return;
    }

    if (tripType === "Roundtrip" && !returnDate) {
      Swal.fire({ icon: 'warning', title: 'Return Date?', text: 'Please select a return date for Roundtrip.' });
      return;
    }

    // Building Query Parameters
    const params = {
      tripType,
      fromCode: fromTerminal.terminal_code,
      fromName: fromTerminal.terminal_name,
      toCode: toTerminal.terminal_code,
      toName: toTerminal.terminal_name,
      depart: departureDate,
      return: tripType === "Roundtrip" ? returnDate : "",
      adults: adults.toString(),
      children: children.toString(),
      infants: infants.toString(),
      cabin: cabinClass
    };

    const queryStr = new URLSearchParams(params).toString();
    navigate(`/flight-result?${queryStr}`);
  };

  return (

<>


  <style>{`

      .hero-section {
          position: relative;
          max-height: 400px;
          background: linear-gradient(rgba(11, 61, 71, 0.8), rgba(22, 96, 112, 0.9)), 
                      url('https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&q=80&w=2000');
          background-size: cover;
          background-position: center;
          padding: 150px 0 150px 0;
          color: white;
          text-align: center;
        }

        .hero-content h1 {
          font-size: 3rem;
          font-weight: 800;
          margin-bottom: 15px;
          text-shadow: 0 2px 10px rgba(0,0,0,0.2);
        }

        .hero-content p {
          font-size: 1.2rem;
          opacity: 0.9;
          margin-bottom: 40px;
        }

        .floating-booking-container {
          max-width: 1100px;
          margin: -80px auto 50px auto;
          position: relative;
          z-index: 10;
          padding: 0 15px;
        }


        .hotel-hero-card {
          background: #ffffff;
          border-radius: 24px;
          padding: 35px;
          box-shadow: 0 20px 60px rgba(0,0,0,0.1);
          max-width: 1150px;
          margin: 40px auto;
          border: 1px solid #f0f0f0;
        }

        .hotel-grid-slick {
          display: grid;
          grid-template-columns: 1.5fr 1fr 1fr 1.2fr auto;
          gap: 12px;
          align-items: stretch;
        }

        .input-wrap-slick {
          background: #f8fafc;
          border: 1.5px solid #e2e8f0;
          border-radius: 16px;
          padding: 10px 16px;
          transition: all 0.25s ease;
          cursor: pointer;
          position: relative;
        }

        .input-wrap-slick:hover { border-color: #cbd5e1; background: #f1f5f9; }
        .input-wrap-slick:focus-within {
          border-color: #1a73e8;
          background: #ffffff;
          box-shadow: 0 0 0 4px rgba(26, 115, 232, 0.1);
        }

        .input-wrap-slick label {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #64748b;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .input-wrap-slick input, .val-display {
          border: none;
          background: transparent;
          width: 100%;
          font-size: 15px;
          font-weight: 600;
          color: #1e293b;
          outline: none !important;
          padding: 0;
        }

        .search-results-dropdown {
          position: absolute;
          top: 110%;
          left: 0;
          right: 0;
          background: white;
          border-radius: 16px;
          z-index: 1000;
          max-height: 300px;
          overflow-y: auto;
          box-shadow: 0 10px 30px rgba(0,0,0,0.15);
          padding: 8px;
        }

        .result-item {
          padding: 12px 16px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          gap: 12px;
          cursor: pointer;
          transition: 0.2s;
        }

        .result-item:hover { background: #eff6ff; }
        .result-item .icon-circle {
          width: 32px; height: 32px; background: #e0e7ff;
          color: #4338ca; border-radius: 50%; display: flex; align-items: center; justify-content: center;
        }

        .traveler-dropdown {
          position: absolute;
          top: 110%;
          right: 0;
          width: 320px;
          background: white;
          border-radius: 20px;
          padding: 24px;
          z-index: 1001;
          box-shadow: 0 20px 50px rgba(0,0,0,0.2);
        }

        .counter-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 0;
          border-bottom: 1px solid #f1f5f9;
        }

        .counter-ctrl {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .ctrl-btn {
          width: 32px; height: 32px; border-radius: 50%; border: 1px solid #cbd5e1;
          background: white; color: #1e293b; font-size: 18px; display: flex;
          align-items: center; justify-content: center; transition: 0.2s;
        }

        .ctrl-btn:hover:not(:disabled) { background: #1a73e8; color: white; border-color: #1a73e8; }

        .btn-hotel-search {
          background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%);
          color: white; border: none; border-radius: 16px;
          padding: 0 35px; height: 62px; font-weight: 700;
          transition: all 0.3s ease; display: flex; align-items: center; gap: 10px;
        }

        .btn-hotel-search:hover { transform: translateY(-2px); box-shadow: 0 8px 25px rgba(26, 115, 232, 0.4); }

        @media (max-width: 991px) {
          .hotel-grid-slick { grid-template-columns: 1fr; gap: 10px; }
          .hotel-hero-card { padding: 20px; margin: 15px; }
          .traveler-dropdown { width: 100%; left: 0; }
          .btn-hotel-search { width: 100%; justify-content: center; }
        }
      `}</style>


    <section className="hero-section">
        <div className="container hero-content2">
          <h1>India's No. 1 Flight Booking Sites</h1>
          <p>Travel across the Globe. Best Price guranteed.</p>
        </div>
      </section>


<div className="floating-booking-container"> 


    <div className="flight-form-container">
      {/* Trip Type Selector */}
      <div className="trip-type-row mb-4">
        {["One Way", "Roundtrip" ].map((type) => (
          <button
            key={type}
            className={`btn-type text-white ${tripType === type ? "active" : ""}`}
            onClick={() => setTripType(type)}
          >
            {type}
          </button>
        ))}
      </div>


      <div className="booking-grid"> 
        {/* FROM */}
        <div className="grid-input-box position-relative">
          <label><FaPlaneDeparture className="me-1" /> From</label>
          <input
            type="text"
            className="main-input"
            placeholder="Search Airport"
            value={fromSearch.query}
            onChange={(e) => handleSearch(e.target.value, "from")}
          />
          {fromSearch.results.length > 0 && (
            <ul className="search-results-dropdown shadow-lg">
              {fromSearch.results.map(item => (
                <li key={item.terminal_code} onClick={() => selectTerminal(item, "from")}>
                  <span className="code">{item.terminal_code}</span>
                  <span className="name">{item.terminal_name}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="swap-container">
          <button className="btn-swap shadow-sm" type="button"><HiArrowsRightLeft /></button>
        </div>

        {/* TO */}
        <div className="grid-input-box position-relative">
          <label><FaPlaneArrival className="me-1" /> To</label>
          <input
            type="text"
            className="main-input"
            placeholder="Search Airport"
            value={toSearch.query}
            onChange={(e) => handleSearch(e.target.value, "to")}
          />
          {toSearch.results.length > 0 && (
            <ul className="search-results-dropdown shadow-lg">
              {toSearch.results.map(item => (
                <li key={item.terminal_code} onClick={() => selectTerminal(item, "to")}>
                  <span className="code">{item.terminal_code}</span>
                  <span className="name">{item.terminal_name}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* DEPARTURE */}
        <div className="grid-input-box">
          <label><FaCalendarAlt className="me-1" /> Departure</label>
          <input
            name="departureDate"
            placeholder="Select Date"
            className="main-input date-input"
            readOnly
          />
        </div>

        {/* RETURN */}
        {tripType === "Roundtrip" && (
          <div className="grid-input-box animate-fade-in">
            <label><FaCalendarAlt className="me-1" /> Return</label>
            <input
              name="returnDate"
              placeholder="Select Date"
              className="main-input date-input"
              readOnly
            />
          </div>
        )}

        {/* TRAVELLERS */}
        <div 
          className="grid-input-box position-relative" 
          ref={travelerRef}
          onClick={() => setShowTravelerModal(!showTravelerModal)}
        >
          <label><HiOutlineUserGroup className="me-1" /> Travelers & Class</label>
          <div className="val-display">
            {formData.adults + formData.children + formData.infants} Pax, {formData.cabinClass}
            <HiOutlineChevronDown className="ms-auto" />
          </div>

          {showTravelerModal && (
            <div className="traveler-dropdown shadow-lg animate-fade-in" onClick={(e) => e.stopPropagation()}>
              <h6 className="fw-bold mb-3">Travelers</h6>
              {[
                { label: "Adults", sub: "12+ yrs", key: "adults" },
                { label: "Children", sub: "2-12 yrs", key: "children" },
                { label: "Infants", sub: "Under 2 yrs", key: "infants" }
              ].map(row => (
                <div className="counter-row" key={row.key}>
                  <div>
                    <div className="fw-bold">{row.label}</div>
                    <small className="text-muted">{row.sub}</small>
                  </div>
                  <div className="counter-btns">
                    <button type="button" onClick={() => updateCount(row.key, "dec")}>-</button>
                    <span>{formData[row.key]}</span>
                    <button type="button" onClick={() => updateCount(row.key, "inc")}>+</button>
                  </div>
                </div>
              ))}
              <div className="mt-3 border-top pt-3">
                <label className="small fw-bold text-uppercase">Cabin Class</label>
                <select 
                  className="form-select mt-1" 
                  value={formData.cabinClass}
                  onChange={(e) => setFormData({...formData, cabinClass: e.target.value})}
                >
                  <option>Economy</option>
                  <option>Premium Economy</option>
                  <option>Business</option>
                  <option>First Class</option>
                </select>
              </div>
              <button className="btn btn-primary w-100 mt-3" type="button" onClick={() => setShowTravelerModal(false)}>
                Apply
              </button>
            </div>
          )}
        </div>
      </div>

      {/* SEARCH ACTION BUTTON - PLACED CORRECTLY AT THE BOTTOM */}
      <div className="search-action-container mt-4 text-center">
        <button className="btn-search-grad  shadow-lg" onClick={onSearchFlights}>
          <FaSearch className="me-2" /> Search Flights
        </button>
      </div>
    </div>

    </div>

    </>
  );
};

export default FlightSearch;